import type { ReactNode } from "react";
import { useCurrentCommunityContext } from "@circle-react/apps/AuthenticationApp";

/* eslint-disable @typescript-eslint/no-unused-vars -- Hook will be used in future implementation */
// @ts-expect-error -- Hook will be used in future implementation
import useIsNewOnboardingFlow from "../hooks/useIsNewOnboardingFlow";

/* eslint-enable @typescript-eslint/no-unused-vars -- Re-enable unused vars check */
import { OnboardingLayout } from "./OnboardingLayout";

export interface OnboardingWrapperProps {
  children: ReactNode;
  title: ReactNode;
  subtitle?: ReactNode;
  step?: string;
  progress?: {
    new: {
      currentStep: number;
      totalSteps: number;
    };
    legacy: string;
  };
  isNarrow?: boolean;
  withCircleBranding?: boolean;
  shouldShowPoweredByCircle?: boolean;
  isVerticallyCenteredOnMobile?: boolean;
  background?: "dark" | "light" | "discover";
  rightPanelContent?: ReactNode;
  rightPanelVariant?: "testimonials" | "community-preview" | "custom";
  communityName?: string;
  isRegisteringAsACommunityMember?: boolean;
  buildingBlocks?: string[];
}

export const OnboardingWrapper = ({
  children,
  title,
  subtitle,
  step,
  progress,
  isNarrow = false,
  withCircleBranding = true,
  shouldShowPoweredByCircle = false,
  isVerticallyCenteredOnMobile = false,
  background = "dark",
}: OnboardingWrapperProps) => {
  const { currentCommunity } = useCurrentCommunityContext();

  return (
    <OnboardingLayout
      community={currentCommunity}
      title={title}
      subtitle={subtitle}
      step={step}
      progress={progress?.legacy}
      isNarrow={isNarrow}
      withCircleBranding={withCircleBranding}
      shouldShowPoweredByCircle={shouldShowPoweredByCircle}
      isVerticallyCenteredOnMobile={isVerticallyCenteredOnMobile}
      background={background}
    >
      {children}
    </OnboardingLayout>
  );
};
